import { action, observable } from 'mobx'
import { StoreExt } from '@utils/reactExt'
import { ICashShopInfo, Schema$ServerCheck } from '@protocol/game'

import { extend } from 'lodash'
import { message } from 'antd'

export type cashShopList = ICashShopInfo.Item
export type cashShopTrackItem = ICashShopInfo.Item

export class GameStore extends StoreExt {
  cashShops: cashShopList[]

  @observable
  tracks: cashShopTrackItem[]

  constructor() {
    super()
    this.cashShops = []
  }

  @action
  getList = async () => {
    try {
      const { data } = await this.api.game.getCashShopInfo()
      this.cashShops = data
      const tracks = []
      for (const el of this.cashShops) {
        const track: cashShopTrackItem = extend({}, el)
        tracks.push(track)
      }

      this.setCashShops(tracks)
    } catch (err) {
      message.error(err.message)
    }
  }

  @action
  setCashShops = (tracks: cashShopTrackItem[]): cashShopTrackItem[] => {
    this.tracks = tracks
    return tracks
  }

  @action
  fetchServerCheck = async (): Promise<Schema$ServerCheck> => {
    const res = await this.api.game.getServerCheck()
    return res
  }
}

export default new GameStore()
